// extracted by mini-css-extract-plugin
export default {"hero":"InstitutionalView_hero__tjgc-"};